import { Box, Typography } from '@mui/material';
import React from 'react';
import { footerContainerStyles, footerCountDivStyles, footerCountProps, footerLabelProps } from '../dashboardStyles';

interface AvailabilityFooterProps {
  counts: {
    available: number;
    unavailable: number;
    requestedOff: number;
  };
}

export function AvailabilityFooter({ counts }: AvailabilityFooterProps) {
  const { available, unavailable, requestedOff } = counts;
  return (
    <Box sx={footerContainerStyles}>
      <Box sx={footerCountDivStyles}>
        <Typography {...footerCountProps}>{available}</Typography>
        <Typography {...footerLabelProps}>Available</Typography>
      </Box>

      {/* LATER TODO: Request Off Logic */}
      {/* <Box sx={footerCountDivStyles}>
        <Typography {...footerCountProps}>{requestedOff}</Typography>
        <Typography {...footerLabelProps}>Requested Off</Typography>
      </Box> */}

      <Box sx={footerCountDivStyles}>
        <Typography {...footerCountProps}>{unavailable}</Typography>
        <Typography {...footerLabelProps}>Unavailable</Typography>
      </Box>
    </Box>
  );
}
